"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.criteriaFilterFiltered = exports.criteriaFilterDefault = void 0;
var Route1 = {
    label: "Route 1",
    key: "Route1",
    helpText: "Route1",
    required: false,
    type: "checkbox",
    isDate: false
};
var Route2 = {
    label: "Route 2",
    key: "Route2",
    helpText: "Route2",
    required: false,
    type: "checkbox",
    isDate: false
};
var Date1 = {
    label: "Date 1 ",
    key: "Date1",
    helpText: "Date 1",
    required: false,
    type: "checkbox",
    isDate: false
};
var Tenant = {
    helpText: "Partners Health System",
    key: "2",
    label: "Partners Health System",
    children: [
        {
            helpText: "Dana Farber Cancer Institute",
            key: "14",
            label: "Dana Farber Cancer Institute"
        },
        {
            helpText: "Brigham & Women's Physicians Organization",
            key: "16",
            label: "Brigham & Women's Physicians Organization"
        },
        {
            helpText: "Spaulding Rehab Hospital",
            key: "11",
            label: "Spaulding Rehab Hospital"
        }
    ]
};
var otherTenant = {
    helpText: "Other Health System",
    key: "20",
    label: "Other Health System",
    children: [
        {
            helpText: "Other Hospital 1",
            key: "24",
            label: "Other Hospital 1"
        },
        {
            helpText: "Other Hospital 2",
            key: "26",
            label: "Other Hospital 2"
        }
    ]
};
var formDefinitionTenant = {
    fieldGroups: [
        {
            label: "Filter Tenant",
            fields: [Tenant, otherTenant]
        }
    ]
};
var formDefinitionRouting = {
    fieldGroups: [
        {
            label: "Filter Routing",
            fields: [Route1, Route2]
        }
    ]
};
var routingCriteria = {
    name: "Routing",
    key: "routing",
    formDefinition: formDefinitionRouting
};
var accessionCriteria = {
    label: "Accession #",
    key: "accession",
    helpText: "The accession number",
    placeholder: "Accession #",
    required: true,
    type: "text"
};
var providerCriteria = {
    label: "Provider #",
    key: "provider",
    helpText: "The provider number",
    placeholder: "Provider #",
    required: true,
    type: "text"
};
var formDefinitionServiceDate = {
    fieldGroups: [
        {
            label: "Filter Service",
            fields: [Date1]
        }
    ]
};
var tenantCriteria = {
    name: "Tenant",
    key: "tenant_code",
    formDefinition: formDefinitionTenant,
    icon: "",
    isExtra: true
};
var serviceDateCriteria = {
    name: "Service Date",
    key: "date_of_service",
    formDefinition: formDefinitionServiceDate,
    icon: "",
    isDate: true,
    isExtra: true
};
var automationDateCriteria = {
    name: "Automation Date",
    key: "automation_decision_datetime",
    formDefinition: formDefinitionServiceDate,
    icon: "",
    isDate: true,
    isExtra: true
};
exports.criteriaFilterDefault = {
    filters: [],
    dateFilter: undefined,
    filterForms: [
        tenantCriteria,
        routingCriteria,
        serviceDateCriteria,
        automationDateCriteria
    ],
    searchForms: [accessionCriteria, providerCriteria]
};
//Use for testing to auto apply filter
exports.criteriaFilterFiltered = {
    filters: [
        { key: "tenant_code", terms: ["14"] },
        { key: "routing", terms: ["Route2"] }
    ],
    dateFilter: {
        key: "date_of_service",
        terms: ["2020-06-08"],
        type: "GREATER_THAN_EQUAL"
    },
    filterForms: [
        tenantCriteria,
        routingCriteria,
        serviceDateCriteria,
        automationDateCriteria
    ],
    searchForms: [accessionCriteria, providerCriteria]
};
//# sourceMappingURL=criteria.js.map